import { GET_SURVEY_GROUP_STATUS_ENDPOINT } from '../../../common/config/api_endpoints';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../redux/epics/utils';

const SURVEY_GROUP_STATUS_ACTION_TYPES = createAPILifecycleActionTypes('SURVEY_GROUP_STATUS');

export const surveyGroupStatusAction = createAPILifecycleActions(
  SURVEY_GROUP_STATUS_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SURVEY_GROUP_STATUS_ACTION_TYPES.BEGIN:
      return { ...state, isFetching: true, error: null };
    case SURVEY_GROUP_STATUS_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: payload,
        error: null,
      };
    case SURVEY_GROUP_STATUS_ACTION_TYPES.FAILURE:
      return { ...state, isFetching: false, data: null, error: payload };
    case SURVEY_GROUP_STATUS_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const surveyGroupStatusEpic = createAmplifyAPICallEpic({
  actionType: SURVEY_GROUP_STATUS_ACTION_TYPES.BEGIN,
  api: GET_SURVEY_GROUP_STATUS_ENDPOINT,
  successCallback: response => [surveyGroupStatusAction.SUCCESS(response.body)],
  errorCallback: error => [surveyGroupStatusAction.FAILURE(error)],
});
